import { Box, Typography, Button, Divider, Grid, useMediaQuery, Dialog, DialogContent, DialogActions, TextField, Stack, FormControl, InputLabel, Select, MenuItem, CardActions, Card, IconButton } from "@mui/material";
import React, { useEffect, useState } from "react";
import { BASE_URL } from "../network/endpoints";
import instId from "../network/instituteId";
import axios from "axios";
import Network from "../network/Network";
import parse from "html-react-parser";
import PlayCircleIcon from '@mui/icons-material/PlayCircle';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import FaQqSection from "../homepage/FaqSection";
import IframFormSection from "../homepage/IframeSection";
import { useSnackbar } from "notistack";
import CloseIcon from '@mui/icons-material/Close';
import { useNavigate } from "react-router-dom";

// Add CSS animations
const globalStyles = `
    @keyframes fadeInUp {
        from {
            opacity: 0;
            transform: translateY(50px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }
    
    @keyframes slideInLeft {
        from {
            opacity: 0;
            transform: translateX(-80px);
        }
        to {
            opacity: 1;
            transform: translateX(0);
        }
    }
    
    @keyframes pulse {
        0%, 100% {
            transform: scale(1);
            box-shadow: 0 0 0 0 rgba(102, 126, 234, 0.7);
        }
        50% {
            transform: scale(1.05);
            box-shadow: 0 0 0 10px rgba(102, 126, 234, 0);
        }
    }
    
    @keyframes float {
        0%, 100% {
            transform: translateY(0px) rotate(0deg);
        }
        50% {
            transform: translateY(-15px) rotate(5deg);
        }
    }
    
    @keyframes shimmer {
        0% {
            background-position: -1200px 0;
        }
        100% {
            background-position: 1200px 0;
        }
    }
    
    @keyframes bounceIn {
        0% {
            opacity: 0;
            transform: scale(0.2) rotate(-45deg);
        }
        50% {
            opacity: 1;
            transform: scale(1.15) rotate(10deg);
        }
        100% {
            opacity: 1;
            transform: scale(1) rotate(0deg);
        }
    }
    
    @keyframes glow {
        0%, 100% {
            box-shadow: 0 0 20px rgba(102, 126, 234, 0.3);
        }
        50% {
            box-shadow: 0 0 40px rgba(102, 126, 234, 0.6);
        }
    }
    
    @keyframes morphBackground {
        0%, 100% {
            border-radius: 60% 40% 30% 70% / 60% 30% 70% 40%;
        }
        50% {
            border-radius: 30% 60% 70% 40% / 50% 60% 30% 60%;
        }
    }
`;

// Inject styles
if (typeof document !== 'undefined') {
    const styleSheet = document.createElement("style");
    styleSheet.innerText = globalStyles;
    document.head.appendChild(styleSheet);
}

const FreeResources = () => {

    const navigate = useNavigate();
    const { enqueueSnackbar } = useSnackbar();
    const isMobile = useMediaQuery("(min-width:600px)");
    const [Endpoints, setEndpoints] = useState('');
    const [coursesList, setCoursesList] = useState([]);
    const [activeCoursesList, setActiveCoursesList] = useState([]);
    const [selectedSceduleList, setSelectedSceduleList] = useState([]);
    const [formModalOpen, setFormModalOpen] = useState(false);
    const [number, setNumber] = useState('');
    const [name, setName] = useState('');
    const [selectCourse, setSelectCourse] = useState("");
    const [selectedItem, setSelectedItem] = useState({});

    useEffect(() => {
        window.scrollTo(0, 0);
        getInstituteDetail();
        getAllCourses();
    }, []);

    useEffect(() => {
        if (coursesList?.length > 0) {
            getMergedSchedules()
        }
    }, [coursesList])

    const getInstituteDetail = async () => {
        try {
            let requestOptions = {
                // headers: { "X-Auth": token },
                withCredentials: false,
            };
            const response = await axios.get(
                BASE_URL + "/getMetaData/fetch-institute/" + instId,
                requestOptions
            );
            if (response?.data?.errorCode === 0) {
                setEndpoints(response?.data?.instituteTechSetting?.mediaUrl)
                // Endpoints = response?.data?.instituteTechSetting?.mediaUrl
            };
        } catch (error) {
            console.log(error);
        }
    };

    const getAllCourses = async () => {
        const response = await Network.fetchCourses(instId);
        const course = response?.courses || [];
        const ActivefilteredCourses = course.filter(course =>
            course?.active === true
        );
        setActiveCoursesList(ActivefilteredCourses);

        const filteredCourses = course.filter(course =>
            course?.active === true &&
            course?.tags?.some(tagObj => tagObj?.tag?.toLowerCase() === "free")
        );

        setCoursesList(filteredCourses);
    };

    const getMergedSchedules = async () => {
        try {
            let allSchedules = [];

            await Promise.all(
                coursesList.map(async (course) => {
                    const response = await Network.fetchCheduleApi(course.id, 0);
                    if (response?.contentList) {
                        const updatedList = response.contentList.map((item) => ({
                            ...item,
                            parentCourseId: course.id, // ✅ Add course ID here
                        }));
                        allSchedules = [...allSchedules, ...updatedList];
                    }
                })
            );
            setSelectedSceduleList(allSchedules);
        } catch (error) {
            console.error("Error fetching course schedules:", error);
        }
    };

    const handleCardClick = (item) => {
        setSelectedItem(item);
        setFormModalOpen(true);
    };

    const handleClose = () => {
        setName('');
        setNumber('');
        setSelectCourse('');
        setFormModalOpen(false);
    }
    // console.log('selectedItem', selectedItem);


    const handleSubmit = async () => {
        try {
            const body = {
                instId: instId,
                firstName: name,
                lastName: name,
                contact: number,
                campaignId: null,
                contentId: selectedItem?.parentCourseId,
                enquiryType: "course"
            }
            let requestOptions = {
                // headers: { "X-Auth": token },
                withCredentials: false,
            };
            const response = await axios.post(
                BASE_URL + "leadManagement/create-lead-form", body,
                requestOptions
            );

            if (response?.data?.errorCode !== 0) {
                enqueueSnackbar(`${response?.data?.errorDescription}`, { variant: 'error', autoHideDuration: 3000 })
            } else if (response?.data?.errorCode === 0) {
                enqueueSnackbar(`Thank You For Submitting`, { variant: "success", autoHideDuration: 3000 }
                );
                if (selectedItem?.entityType === "video" && selectedItem?.video?.video) {
                    window.open(Endpoints + selectedItem?.video?.video, "_blank");
                } else if (selectedItem?.entityType === "note" && selectedItem?.note?.note) {
                    window.open(Endpoints + selectedItem?.note?.note, "_blank");
                } else if (selectedItem?.entityType === "blog" && selectedItem?.blog?.blog) {
                    navigate('/blog', { state: { blogData: selectedItem } })
                } else {
                    console.warn("No valid URL found for this item.");
                }
                setName('');
                setNumber('');
                setSelectCourse('');
                handleClose();
            }

        } catch (error) {
            console.log(error);
        }
    }

    const handleChangeCourse = (event) => {
        setSelectCourse(event.target.value)
    };

    return (
        <React.Fragment>
            <Box sx={{ 
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 50%, #667eea 100%)',
                // minHeight: '100vh',
                pt: { xs:8,sm: 8 },
                pb: { xs:  6,sm: 6},
                position: 'relative',
                overflow: 'hidden',
                '&::before': {
                    content: '""',
                    position: 'absolute',
                    top: '-50%',
                    left: '-50%',
                    width: '200%',
                    height: '200%',
                    background: 'radial-gradient(circle at 25% 25%, rgba(255, 255, 255, 0.1) 0%, transparent 50%), radial-gradient(circle at 75% 75%, rgba(118, 75, 162, 0.2) 0%, transparent 50%), radial-gradient(circle at 50% 50%, rgba(102, 126, 234, 0.1) 0%, transparent 70%)',
                    animation: 'morphBackground 15s ease-in-out infinite, float 8s ease-in-out infinite',
                },
                '&::after': {
                    content: '""',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    background: 'linear-gradient(45deg, transparent 30%, rgba(255,255,255,0.03) 50%, transparent 70%)',
                    backgroundSize: '400% 400%',
                    animation: 'shimmer 4s linear infinite',
                },
            }}>
                {/* Floating Background Elements */}
                <Box sx={{
                    position: 'absolute',
                    top: '10%',
                    right: '10%',
                    width: '100px',
                    height: '100px',
                    background: 'linear-gradient(135deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.05) 100%)',
                    borderRadius: '50%',
                    animation: 'float 6s ease-in-out infinite',
                    zIndex: 0,
                }}>
                    <Box sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: '60%',
                        height: '60%',
                        background: 'linear-gradient(135deg, rgba(102, 126, 234, 0.3) 0%, rgba(118, 75, 162, 0.3) 100%)',
                        borderRadius: '50%',
                        animation: 'pulse 3s ease-in-out infinite',
                    }} />
                </Box>

                <Box sx={{
                    position: 'absolute',
                    bottom: '20%',
                    left: '5%',
                    width: '80px',
                    height: '80px',
                    background: 'linear-gradient(135deg, rgba(255,255,255,0.08) 0%, rgba(255,255,255,0.03) 100%)',
                    borderRadius: '50%',
                    animation: 'float 8s ease-in-out infinite reverse',
                    zIndex: 0,
                }} />

                {/* Hero Section */}
                <Box sx={{ 
                    textAlign: 'center', 
                    mb: { xs: 6, sm: 8 },
                    px: { xs: 2, sm: 4 },
                    position: 'relative',
                    zIndex: 1,
                }}>
                    <Box sx={{
                        display: 'inline-block',
                        background: 'linear-gradient(135deg, rgba(255,255,255,0.15) 0%, rgba(255,255,255,0.05) 100%)',
                        backdropFilter: 'blur(20px)',
                        border: '1px solid rgba(255,255,255,0.2)',
                        borderRadius: '50px',
                        px: 4,
                        py: 1,
                        mb: 3,
                        animation: 'fadeInUp 1s ease-out',
                    }}>
                        <Typography sx={{
                            color: 'rgba(255,255,255,0.9)',
                            fontSize: '14px',
                            fontWeight: 600,
                            letterSpacing: '2px',
                            textTransform: 'uppercase',
                        }}>
                            ✨ Premium Content • Absolutely Free ✨
                        </Typography>
                    </Box>

                    <Typography 
                        variant="h1" 
                        sx={{ 
                            fontWeight: 900,
                            background: 'linear-gradient(135deg, #ffffff 0%, #f0f4ff 50%, #ffffff 100%)',
                            backgroundClip: 'text',
                            WebkitBackgroundClip: 'text',
                            WebkitTextFillColor: 'transparent',
                            mb: 3,
                            fontSize: { xs: '2.5rem', sm: '3.5rem', md: '4.5rem' },
                            lineHeight: 1.1,
                            textShadow: '0 10px 30px rgba(0,0,0,0.3)',
                            animation: 'bounceIn 1.5s ease-out',
                            letterSpacing: '-0.02em',
                        }}
                    >
                        Free Learning
                        <br />
                        <span style={{
                            background: 'linear-gradient(135deg, #ff6b6b 0%, #ffd93d 50%, #6bcf7f 100%)',
                            backgroundClip: 'text',
                            WebkitBackgroundClip: 'text',
                            WebkitTextFillColor: 'transparent',
                        }}>
                            Resources
                        </span>
                    </Typography>
                    
                    {/* <Typography 
                        variant="h5" 
                        sx={{ 
                            color: 'rgba(255,255,255,0.85)',
                            maxWidth: '700px',
                            mx: 'auto',
                            fontSize: { xs: '1.1rem', sm: '1.3rem', md: '1.5rem' },
                            animation: 'slideInLeft 1.2s ease-out 0.5s both',
                            lineHeight: 1.6,
                            fontWeight: 400,
                            textShadow: '0 2px 10px rgba(0,0,0,0.2)',
                        }}
                    >
                        🎯 Unlock your potential with our curated collection of premium educational content
                        <br />
                        📚 Videos • 📝 Notes • 📖 Resources
                    </Typography> */}

                    {/* <Box sx={{
                        mt: 4,
                        display: 'flex',
                        justifyContent: 'center',
                        gap: 3,
                        flexWrap: 'wrap',
                        animation: 'fadeInUp 1s ease-out 1s both',
                    }}>
                        {[
                            { icon: '🎥', text: 'HD Videos', count: '500+' },
                            { icon: '📚', text: 'Study Notes', count: '1000+' },
                            { icon: '🏆', text: 'Resources', count: '2000+' },
                        ].map((item, index) => (
                            <Box key={index} sx={{
                                background: 'linear-gradient(135deg, rgba(255,255,255,0.15) 0%, rgba(255,255,255,0.05) 100%)',
                                backdropFilter: 'blur(15px)',
                                border: '1px solid rgba(255,255,255,0.2)',
                                borderRadius: '20px',
                                px: 3,
                                py: 2,
                                textAlign: 'center',
                                animation: `fadeInUp 0.8s ease-out ${1.2 + index * 0.2}s both`,
                                transition: 'all 0.3s ease',
                                '&:hover': {
                                    transform: 'translateY(-5px)',
                                    background: 'linear-gradient(135deg, rgba(255,255,255,0.25) 0%, rgba(255,255,255,0.15) 100%)',
                                },
                            }}>
                                <Typography sx={{ fontSize: '1.5rem', mb: 0.5 }}>{item.icon}</Typography>
                                <Typography sx={{ color: 'white', fontWeight: 700, fontSize: '1.2rem' }}>{item.count}</Typography>
                                <Typography sx={{ color: 'rgba(255,255,255,0.8)', fontSize: '0.9rem' }}>{item.text}</Typography>
                            </Box>
                        ))}
                    </Box> */}
                </Box>

                <Box sx={{ 
                    px: { xs: 2, sm: 4, md: 6 },
                    position: 'relative',
                    zIndex: 1,
                }}>
                    <Grid container spacing={{ xs: 3, sm: 4, md: 5 }} sx={{ justifyContent: 'center' }}>
                        {
                            selectedSceduleList?.length > 0 && selectedSceduleList?.map((item, i) => {
                                if (item?.paid === false) {
                                    return <Grid key={i} item xs={12} sm={6} md={4} lg={3}>
                                        <Box sx={{ 
                                            background: 'linear-gradient(135deg, rgba(255, 255, 255, 0.25) 0%, rgba(255, 255, 255, 0.1) 100%)',
                                            backdropFilter: 'blur(30px)',
                                            border: '1px solid rgba(255, 255, 255, 0.3)',
                                            borderRadius: '25px',
                                            overflow: 'hidden',
                                            cursor: 'pointer',
                                            transition: 'all 0.5s cubic-bezier(0.4, 0, 0.2, 1)',
                                            boxShadow: '0 20px 60px rgba(0,0,0,0.2), inset 0 1px 0 rgba(255,255,255,0.3)',
                                            animation: `fadeInUp 1s ease-out ${i * 0.2}s both`,
                                            position: 'relative',
                                            height: '100%',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            '&::before': {
                                                content: '""',
                                                position: 'absolute',
                                                top: 0,
                                                left: '-100%',
                                                width: '100%',
                                                height: '100%',
                                                background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent)',
                                                transition: 'left 1s',
                                                zIndex: 1,
                                            },
                                            '&::after': {
                                                content: '""',
                                                position: 'absolute',
                                                top: 0,
                                                left: 0,
                                                right: 0,
                                                bottom: 0,
                                                background: 'linear-gradient(135deg, rgba(102, 126, 234, 0.05) 0%, rgba(118, 75, 162, 0.05) 100%)',
                                                opacity: 0,
                                                transition: 'opacity 0.5s ease',
                                                borderRadius: '25px',
                                                zIndex: 0,
                                            },
                                            '&:hover': {
                                                transform: 'translateY(-20px) scale(1.05)',
                                                boxShadow: '0 40px 100px rgba(102, 126, 234, 0.3), inset 0 1px 0 rgba(255,255,255,0.5)',
                                                borderColor: 'rgba(255,255,255,0.5)',
                                                '&::before': {
                                                    left: '100%',
                                                },
                                                '&::after': {
                                                    opacity: 1,
                                                },
                                            },
                                        }} 
                                        onClick={() => handleCardClick(item)}
                                        >
                                            {item?.thumb && (
                                                <Box sx={{ 
                                                    position: 'relative',
                                                    overflow: 'hidden',
                                                    height: '200px',
                                                    borderRadius: '20px 20px 0 0',
                                                }}>
                                                    <img 
                                                        src={Endpoints + item?.thumb} 
                                                        alt={item?.title}
                                                        style={{ 
                                                            // width: "100%", 
                                                            height: "100%",
                                                            objectFit: "cover",
                                                            objectPosition: "center",
                                                            transition: 'transform 0.6s ease',
                                                            filter: 'brightness(1.1) contrast(1.1)',
                                                        }} 
                                                        onMouseEnter={(e) => e.target.style.transform = 'scale(1.1)'}
                                                        onMouseLeave={(e) => e.target.style.transform = 'scale(1)'}
                                                    />

                                                    {/* Enhanced Media Type Icon */}
                                                    <Box sx={{
                                                        position: 'absolute',
                                                        top: 15,
                                                        right: 15,
                                                        background: 'linear-gradient(135deg, rgba(255,255,255,0.95) 0%, rgba(255,255,255,0.85) 100%)',
                                                        borderRadius: '50%',
                                                        p: 1.5,
                                                        backdropFilter: 'blur(15px)',
                                                        border: '2px solid rgba(102, 126, 234, 0.3)',
                                                        zIndex: 3,
                                                        animation: 'float 4s ease-in-out infinite',
                                                        boxShadow: '0 10px 30px rgba(102, 126, 234, 0.3)',
                                                    }}>
                                                        {item?.entityType === "video" || item?.entityType === "blog" ? 
                                                            <PlayCircleIcon sx={{ 
                                                                color: '#667eea', 
                                                                fontSize: '1.5rem',
                                                                filter: 'drop-shadow(0 2px 4px rgba(102, 126, 234, 0.3))',
                                                            }} /> : 
                                                            <PictureAsPdfIcon sx={{ 
                                                                color: '#764ba2', 
                                                                fontSize: '1.5rem',
                                                                filter: 'drop-shadow(0 2px 4px rgba(118, 75, 162, 0.3))',
                                                            }} />
                                                        }
                                                    </Box>
                                                </Box>
                                            )}

                                            <Box sx={{ 
                                                p: 4,
                                                flexGrow: 1,
                                                display: 'flex',
                                                flexDirection: 'column',
                                                justifyContent: 'space-between',
                                                position: 'relative',
                                                zIndex: 2,
                                            }}>
                                                <Box>
                                                    {/* Title and FREE tag in same row */}
                                                    <Box sx={{
                                                        display: 'flex',
                                                        justifyContent: 'space-between',
                                                        alignItems: 'flex-start',
                                                        mb: 3,
                                                        gap: 2,
                                                    }}>
                                                        <Typography 
                                                            variant='h5' 
                                                            sx={{ 
                                                                fontWeight: 800,
                                                                color: "rgba(255,255,255,0.95)",
                                                                fontSize: { xs: '1.1rem', sm: '1.2rem' },
                                                                lineHeight: 1.3,
                                                                textShadow: '0 4px 12px rgba(0,0,0,0.4)',
                                                                transition: 'all 0.3s ease',
                                                                letterSpacing: '-0.01em',
                                                                flex: 1,
                                                                '&:hover': {
                                                                    color: 'rgba(255,255,255,1)',
                                                                    textShadow: '0 6px 20px rgba(0,0,0,0.6)',
                                                                },
                                                            }}
                                                        >
                                                            {item?.title}
                                                        </Typography>

                                                        {/* Premium FREE Badge */}
                                                        <Box sx={{
                                                            background: 'linear-gradient(135deg, #ff6b6b 0%, #ffd93d 50%, #6bcf7f 100%)',
                                                            borderRadius: '20px',
                                                            px: 2,
                                                            py: 0.5,
                                                            boxShadow: '0 8px 25px rgba(255, 107, 107, 0.4)',
                                                            animation: 'glow 2s ease-in-out infinite',
                                                            border: '2px solid rgba(255,255,255,0.9)',
                                                            flexShrink: 0,
                                                        }}>
                                                            <Typography sx={{ 
                                                                color: "white", 
                                                                fontSize: "10px", 
                                                                fontWeight: 900,
                                                                textShadow: '0 2px 4px rgba(0,0,0,0.5)',
                                                                letterSpacing: '1px',
                                                                textTransform: 'uppercase',
                                                            }}>
                                                                ✨ FREE ✨
                                                            </Typography>
                                                        </Box>
                                                    </Box>
                                                </Box>

                                                <Box sx={{ mt: 'auto' }}>
                                                    <Box sx={{
                                                        background: 'linear-gradient(135deg, rgba(255,255,255,0.2) 0%, rgba(255,255,255,0.1) 100%)',
                                                        backdropFilter: 'blur(10px)',
                                                        borderRadius: '18px',
                                                        px: 3,
                                                        py: 2,
                                                        border: '1px solid rgba(255,255,255,0.3)',
                                                        transition: 'all 0.3s ease',
                                                        '&:hover': {
                                                            background: 'linear-gradient(135deg, rgba(255,255,255,0.3) 0%, rgba(255,255,255,0.2) 100%)',
                                                            transform: 'translateY(-2px)',
                                                        },
                                                    }}>
                                                        <Typography 
                                                            variant='body2' 
                                                            sx={{ 
                                                                color: "rgba(255,255,255,0.9)",
                                                                fontSize: "14px",
                                                                fontWeight: 600,
                                                                textAlign: 'center',
                                                                textShadow: '0 2px 8px rgba(0,0,0,0.3)',
                                                            }}
                                                        >
                                                            �️ {item.createdAt ? new Date(item.createdAt).toLocaleString('en-US', {
                                                                month: 'short',
                                                                day: 'numeric',
                                                                year: 'numeric',
                                                                hour: 'numeric',
                                                                minute: 'numeric',
                                                                hour12: true
                                                            }) : ""}
                                                        </Typography>
                                                    </Box>
                                                </Box>
                                            </Box>
                                        </Box>
                                    </Grid>
                                }
                                return null;
                            })
                        }
                        {
                            selectedSceduleList?.length === 0 && (
                                <Grid item xs={12}>
                                    <Box sx={{ 
                                        textAlign: "center", 
                                        py: 10,
                                        background: 'linear-gradient(135deg, rgba(255,255,255,0.2) 0%, rgba(255,255,255,0.1) 100%)',
                                        backdropFilter: 'blur(30px)',
                                        border: '2px solid rgba(255,255,255,0.3)',
                                        borderRadius: '30px',
                                        animation: 'bounceIn 2s ease-out',
                                        boxShadow: '0 30px 80px rgba(0,0,0,0.2), inset 0 1px 0 rgba(255,255,255,0.3)',
                                        position: 'relative',
                                        overflow: 'hidden',
                                        '&::before': {
                                            content: '""',
                                            position: 'absolute',
                                            top: '-50%',
                                            left: '-50%',
                                            width: '200%',
                                            height: '200%',
                                            background: 'radial-gradient(circle, rgba(255,255,255,0.1) 0%, transparent 70%)',
                                            animation: 'float 8s ease-in-out infinite',
                                        },
                                    }}>
                                        <Box sx={{ position: 'relative', zIndex: 1 }}>
                                            <Typography 
                                                variant="h2" 
                                                sx={{ 
                                                    fontWeight: 900,
                                                    color: 'rgba(255,255,255,0.95)',
                                                    mb: 3,
                                                    fontSize: { xs: '2rem', sm: '3rem', md: '3.5rem' },
                                                    textShadow: '0 10px 30px rgba(0,0,0,0.3)',
                                                    letterSpacing: '-0.02em',
                                                }}
                                            >
                                                🚀 Coming Soon!
                                            </Typography>
                                            <Typography 
                                                variant="h5" 
                                                sx={{ 
                                                    color: 'rgba(255,255,255,0.8)',
                                                    fontSize: { xs: '1.2rem', sm: '1.5rem' },
                                                    fontWeight: 400,
                                                    textShadow: '0 5px 15px rgba(0,0,0,0.2)',
                                                    mb: 3,
                                                }}
                                            >
                                                Amazing free resources are being crafted for you
                                            </Typography>
                                            <Box sx={{
                                                display: 'inline-block',
                                                background: 'linear-gradient(135deg, rgba(255,255,255,0.3) 0%, rgba(255,255,255,0.2) 100%)',
                                                backdropFilter: 'blur(15px)',
                                                border: '1px solid rgba(255,255,255,0.4)',
                                                borderRadius: '25px',
                                                px: 4,
                                                py: 2,
                                                animation: 'pulse 2s ease-in-out infinite',
                                            }}>
                                                <Typography sx={{
                                                    color: 'rgba(255,255,255,0.9)',
                                                    fontSize: '1rem',
                                                    fontWeight: 600,
                                                    letterSpacing: '1px',
                                                }}>
                                                    ✨ Stay Tuned ✨
                                                </Typography>
                                            </Box>
                                        </Box>
                                    </Box>
                                </Grid>
                            )
                        }
                    </Grid>
                </Box>
            </Box>

            {/* Ultra Modern Dialog */}
            <Dialog 
                open={formModalOpen} 
                onClose={() => setFormModalOpen(false)}
                PaperProps={{
                    sx: {
                        borderRadius: '30px',
                        background: 'linear-gradient(135deg, rgba(102, 126, 234, 0.95) 0%, rgba(118, 75, 162, 0.95) 100%)',
                        backdropFilter: 'blur(40px)',
                        border: '2px solid rgba(255,255,255,0.3)',
                        boxShadow: '0 50px 100px rgba(0,0,0,0.3), inset 0 1px 0 rgba(255,255,255,0.3)',
                        maxWidth: '550px',
                        width: '95%',
                        margin: '20px',
                        position: 'relative',
                        overflow: 'hidden',
                        '&::before': {
                            content: '""',
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            background: 'linear-gradient(45deg, transparent 30%, rgba(255,255,255,0.1) 50%, transparent 70%)',
                            animation: 'shimmer 3s linear infinite',
                        },
                    }
                }}
                BackdropProps={{
                    sx: {
                        backgroundColor: 'rgba(0,0,0,0.7)',
                        backdropFilter: 'blur(15px)',
                    }
                }}
            >
                <DialogContent sx={{ 
                    padding: 0,
                    background: 'transparent',
                }}>
                    <Card sx={{ 
                        borderRadius: '30px',
                        background: 'transparent',
                        boxShadow: 'none',
                        p: 5,
                        position: 'relative',
                        overflow: 'hidden',
                        zIndex: 1,
                    }}>
                        <IconButton
                            aria-label="close"
                            onClick={handleClose}
                            sx={{
                                position: 'absolute',
                                right: 25,
                                top: 25,
                                background: 'rgba(255,255,255,0.2)',
                                backdropFilter: 'blur(15px)',
                                border: '2px solid rgba(255,255,255,0.3)',
                                color: 'rgba(255,255,255,0.9)',
                                transition: 'all 0.4s ease',
                                zIndex: 2,
                                '&:hover': {
                                    background: 'rgba(255,255,255,0.3)',
                                    transform: 'scale(1.15) rotate(90deg)',
                                    borderColor: 'rgba(255,255,255,0.5)',
                                },
                            }}
                        >
                            <CloseIcon />
                        </IconButton>

                        <Box sx={{ 
                            textAlign: 'center',
                            mb: 4,
                            position: 'relative',
                            zIndex: 1,
                        }}>
                            <Box sx={{
                                display: 'inline-block',
                                background: 'linear-gradient(135deg, rgba(255,255,255,0.2) 0%, rgba(255,255,255,0.1) 100%)',
                                backdropFilter: 'blur(15px)',
                                border: '1px solid rgba(255,255,255,0.3)',
                                borderRadius: '25px',
                                px: 3,
                                py: 1,
                                mb: 3,
                                animation: 'float 3s ease-in-out infinite',
                            }}>
                                <Typography sx={{
                                    color: 'rgba(255,255,255,0.9)',
                                    fontSize: '12px',
                                    fontWeight: 600,
                                    letterSpacing: '2px',
                                    textTransform: 'uppercase',
                                }}>
                                    ✨ Premium Access ✨
                                </Typography>
                            </Box>

                            <Typography 
                                variant="h3" 
                                sx={{ 
                                    fontWeight: 900,
                                    color: 'rgba(255,255,255,0.95)',
                                    mb: 3,
                                    fontSize: { xs: '1.8rem', sm: '2.2rem' },
                                    textShadow: '0 8px 25px rgba(0,0,0,0.3)',
                                    letterSpacing: '-0.02em',
                                    lineHeight: 1.2,
                                }}
                            >
                                🎁 Claim Your
                                <br />
                                <span style={{
                                    background: 'linear-gradient(135deg, #ffd93d 0%, #ff6b6b 50%, #6bcf7f 100%)',
                                    backgroundClip: 'text',
                                    WebkitBackgroundClip: 'text',
                                    WebkitTextFillColor: 'transparent',
                                }}>
                                    Free Resource
                                </span>
                            </Typography>
                            
                            <Typography 
                                sx={{ 
                                    color: 'rgba(255,255,255,0.8)',
                                    fontSize: { xs: '1rem', sm: '1.1rem' },
                                    maxWidth: '400px',
                                    mx: 'auto',
                                    lineHeight: 1.6,
                                    textShadow: '0 2px 8px rgba(0,0,0,0.2)',
                                }}
                            >
                                🚀 Enter your details to unlock premium educational content and start your learning journey
                            </Typography>
                        </Box>

                        <Box sx={{ 
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 4,
                            position: 'relative',
                            zIndex: 1,
                        }}>
                            <Box>
                                <Typography sx={{ 
                                    color: "rgba(255,255,255,0.9)", 
                                    fontSize: "16px", 
                                    mb: 1.5,
                                    fontWeight: 700,
                                    textShadow: '0 2px 8px rgba(0,0,0,0.2)',
                                }}>
                                    👤 Your Name
                                </Typography>
                                <TextField
                                    fullWidth
                                    placeholder="e.g. John Doe"
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                    sx={{
                                        '& .MuiOutlinedInput-root': {
                                            background: 'linear-gradient(135deg, rgba(255,255,255,0.25) 0%, rgba(255,255,255,0.15) 100%)',
                                            backdropFilter: 'blur(20px)',
                                            borderRadius: '20px',
                                            border: '2px solid rgba(255,255,255,0.3)',
                                            transition: 'all 0.4s ease',
                                            '&:hover': {
                                                background: 'linear-gradient(135deg, rgba(255,255,255,0.35) 0%, rgba(255,255,255,0.25) 100%)',
                                                transform: 'translateY(-3px)',
                                                boxShadow: '0 15px 35px rgba(0,0,0,0.2)',
                                                borderColor: 'rgba(255,255,255,0.5)',
                                            },
                                            '&.Mui-focused': {
                                                background: 'linear-gradient(135deg, rgba(255,255,255,0.4) 0%, rgba(255,255,255,0.3) 100%)',
                                                transform: 'translateY(-3px)',
                                                boxShadow: '0 20px 40px rgba(255,255,255,0.1)',
                                                borderColor: 'rgba(255,255,255,0.6)',
                                            },
                                            '& fieldset': {
                                                border: 'none',
                                            },
                                        },
                                        '& .MuiInputBase-input': {
                                            padding: '18px 20px',
                                            fontSize: '16px',
                                            color: 'rgba(255,255,255,0.95)',
                                            fontWeight: 500,
                                            '&::placeholder': {
                                                color: 'rgba(255,255,255,0.6)',
                                                opacity: 1,
                                            },
                                        },
                                    }}
                                />
                            </Box>

                            <Box>
                                <Typography sx={{ 
                                    color: "rgba(255,255,255,0.9)", 
                                    fontSize: "16px", 
                                    mb: 1.5,
                                    fontWeight: 700,
                                    textShadow: '0 2px 8px rgba(0,0,0,0.2)',
                                }}>
                                    📱 Mobile Number
                                </Typography>
                                <TextField
                                    fullWidth
                                    type='number'
                                    placeholder='e.g. 1234567890'
                                    value={number}
                                    onChange={(e) => {
                                        const input = e.target.value;
                                        if (/^\d{0,10}$/.test(input)) {
                                            setNumber(input);
                                        }
                                    }}
                                    error={number.length > 0 && number.length !== 10}
                                    helperText={number.length > 0 && number.length !== 10 ? "📵 Phone number must be 10 digits" : ""}
                                    sx={{
                                        '& .MuiOutlinedInput-root': {
                                            background: 'linear-gradient(135deg, rgba(255,255,255,0.25) 0%, rgba(255,255,255,0.15) 100%)',
                                            backdropFilter: 'blur(20px)',
                                            borderRadius: '20px',
                                            border: '2px solid rgba(255,255,255,0.3)',
                                            transition: 'all 0.4s ease',
                                            '&:hover': {
                                                background: 'linear-gradient(135deg, rgba(255,255,255,0.35) 0%, rgba(255,255,255,0.25) 100%)',
                                                transform: 'translateY(-3px)',
                                                boxShadow: '0 15px 35px rgba(0,0,0,0.2)',
                                                borderColor: 'rgba(255,255,255,0.5)',
                                            },
                                            '&.Mui-focused': {
                                                background: 'linear-gradient(135deg, rgba(255,255,255,0.4) 0%, rgba(255,255,255,0.3) 100%)',
                                                transform: 'translateY(-3px)',
                                                boxShadow: '0 20px 40px rgba(255,255,255,0.1)',
                                                borderColor: 'rgba(255,255,255,0.6)',
                                            },
                                            '&.Mui-error': {
                                                borderColor: 'rgba(255, 107, 107, 0.8)',
                                                boxShadow: '0 15px 35px rgba(255, 107, 107, 0.3)',
                                            },
                                            '& fieldset': {
                                                border: 'none',
                                            },
                                        },
                                        '& .MuiInputBase-input': {
                                            padding: '18px 20px',
                                            fontSize: '16px',
                                            color: 'rgba(255,255,255,0.95)',
                                            fontWeight: 500,
                                            '&::placeholder': {
                                                color: 'rgba(255,255,255,0.6)',
                                                opacity: 1,
                                            },
                                        },
                                        '& .MuiFormHelperText-root': {
                                            background: 'linear-gradient(135deg, rgba(255,255,255,0.9) 0%, rgba(255,255,255,0.8) 100%)',
                                            backdropFilter: 'blur(15px)',
                                            borderRadius: '12px',
                                            padding: '8px 12px',
                                            margin: '8px 0 0 0',
                                            color: '#ff6b6b',
                                            fontWeight: 600,
                                            border: '1px solid rgba(255, 107, 107, 0.3)',
                                        },
                                    }}
                                />
                            </Box>

                            <Button
                                disabled={!name || !number || number.length !== 10}
                                onClick={handleSubmit}
                                sx={{
                                    background: !name || !number || number.length !== 10 
                                        ? 'linear-gradient(135deg, rgba(255,255,255,0.2) 0%, rgba(255,255,255,0.1) 100%)' 
                                        : 'linear-gradient(135deg, #ffd93d 0%, #ff6b6b 50%, #6bcf7f 100%)',
                                    color: !name || !number || number.length !== 10 ? 'rgba(255,255,255,0.5)' : 'white',
                                    borderRadius: '20px',
                                    padding: '18px 20px',
                                    fontSize: '18px',
                                    fontWeight: 800,
                                    textTransform: 'none',
                                    boxShadow: !name || !number || number.length !== 10 
                                        ? 'none' 
                                        : '0 15px 40px rgba(255, 215, 61, 0.4)',
                                    transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
                                    position: 'relative',
                                    overflow: 'hidden',
                                    border: '2px solid rgba(255,255,255,0.3)',
                                    textShadow: '0 2px 8px rgba(0,0,0,0.3)',
                                    letterSpacing: '0.5px',
                                    '&::before': {
                                        content: '""',
                                        position: 'absolute',
                                        top: 0,
                                        left: '-100%',
                                        width: '100%',
                                        height: '100%',
                                        background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.3), transparent)',
                                        transition: 'left 0.6s',
                                    },
                                    '&:hover:not(:disabled)': {
                                        transform: 'translateY(-5px) scale(1.02)',
                                        boxShadow: '0 25px 60px rgba(255, 215, 61, 0.6)',
                                        '&::before': {
                                            left: '100%',
                                        },
                                    },
                                    '&:disabled': {
                                        cursor: 'not-allowed',
                                        borderColor: 'rgba(255,255,255,0.2)',
                                    },
                                }}
                            >
                                🚀 Access Free Resource Now
                            </Button>
                        </Box>
                    </Card>
                </DialogContent>
                {/* <DialogActions>
                                <Button onClick={() => setFormModalOpen(false)}>Close</Button>
                            </DialogActions> */}
            </Dialog>
        </React.Fragment>
    );
};

export default FreeResources;
